import { TasksTypes } from './actionTypes';

const INIT_STATE = {
  tasks: [],
  tasksDetail: {},
  tasksAdd: {},
  CountItems: 0,
  deleteId: undefined,
  tasksUpdate: {},
  error: {},
  success: '',
  isLoading: false,
};

const Tasks = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    //GET CLIENT
    case TasksTypes.GET_TASKS:
      return {
        ...state,
        isLoading: true,
      };
    case TasksTypes.GET_TASKS_SUCCESS:
      return {
        ...state,
        tasks: action.payload.taskData,
        CountItems: action.payload.CountItems,
        tasksAdd: {},
        isLoading: false,
      };
    case TasksTypes.GET_TASKS_FAIL:
      return {
        ...state,
        error: action.payload,
        tasks: [],
        tasksAdd: {},
        isLoading: false,
      };

    case TasksTypes.GET_TASKS_DETAIL_SUCCESS:
      return {
        ...state,
        tasksDetail: action.payload,
      };

    case TasksTypes.GET_TASKS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case TasksTypes.ADD_TASKS:
      return {
        ...state,
        isLoading: true,
      };
    case TasksTypes.ADD_TASKS_SUCCESS:
      return {
        ...state,
        tasksAdd: action.payload,
      };
    case TasksTypes.ADD_TASKS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case TasksTypes.DELETE_TASKS:
      return {
        ...state,
        isLoading: true,
      };
    case TasksTypes.DELETE_TASKS_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case TasksTypes.DELETE_TASKS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case TasksTypes.UPDATE_TASKS:
      return {
        ...state,
        isLoading: true,
      };

    case TasksTypes.UPDATE_TASKS_SUCCESS:
      return {
        ...state,
        tasksUpdate: action.payload,
      };
    case TasksTypes.UPDATE_TASKS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default Tasks;
